module.exports = __webpack_public_path__ + "img/女孩2.078b80be.png";